export const ReleaseDate = ({ entry, testId }) => {
  const published = entry.published_at && new Date(entry.published_at);
  const valid = published && !Number.isNaN(published.getTime());
  return <div data-testid={testId} className="text-[11px] leading-relaxed text-white/50 break-words">
    {valid ? <span>Published {published.toLocaleString(undefined, { timeZone: "UTC", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })} UTC</span> : <>
      {entry.development_date && <span className="block">Updated {entry.development_date} UTC</span>}
      <span>{entry.publication_status === "pending" ? "Publication not yet recorded" : "Publication date unverified"}</span>
    </>}
  </div>;
};